import { FlexRow } from "@similarweb/ui-components";
import styled from "styled-components";

export const StyledTrendBar = styled(FlexRow)`
    align-items: end;
    height: 40px;
`;
